// extracted by mini-css-extract-plugin
module.exports = {"nav":"map--nav--29TWD","btn":"map--btn--1jcHO"};